import NotificationsHeader from './NotificationsHeader.component';

export default NotificationsHeader;
